
import {
    styled,
    Typography as UiTypography,
} from "@l2r-front/l2r-ui"

export const ButtonWrapper = styled("div")(({ disabled, theme }) => ({
    alignItems: "center",
    border: `1px dashed ${theme.palette["_components/input/enabledBorder"].main}`,
    borderRadius: theme.spacing(3),
    cursor: disabled ? "default" : "pointer",
    display: "flex",
    padding: theme.spacing(4, 3),
    position: "relative",
    justifyContent: "space-between",

    "&:hover": {
        "& > button": {
            backgroundColor: !disabled ? theme.palette["brand logiroad/secondary/400"].main
                : theme.palette["action/disabledBackground"].main,
        },
    },
}))

export const Typography = styled(UiTypography)(({ color, theme }) => ({
    color: theme.palette[color].main,
}))